export function toStringExpensive(r, content = "") {
  if (typeof r === "string") return r;
  else if (typeof r.type === "function") r = r.type(r.props);
  else if (typeof r.type === "string") {
    content += buildTag(r);
    if (r.props.children) {
      if (Array.isArray(r.props.children)) {
        r.props.children.forEach((child) => {
          content += toStringExpensive(child);
        });
      } else {
        content += toStringExpensive(r.props.children);
      }
    }
    content += `</${r.type}>`;
  } else if (r.props.children) {
    if (Array.isArray(r.props.children)) {
      r.props.children.forEach((child) => {
        content += toStringExpensive(child);
      });
    } else {
      content += toStringExpensive(r.props.children);
    }
  }
  

  return content;
}

// const cache = new Map();

export function buildTag(r) {
  let tag = `<${r.type}`;
  for (const key in r.props) {
    if (key === "children") continue;
    if (key === "style") {
      tag += ` style="`;
      for (const style in r.props.style) {
        tag += `${style}:${r.props.style[style]};`;
      }
      tag += `"`;
    }
    // if (key === "onClick") {
      // const fn = r.props[key];
      // const name = cache[fn];
      // if (!name) {
      //   const id = Math.random().toString(36).substring(7);
      //   cache[fn] = id;
      //   window[id] = fn;
      // }
      // tag += ` onclick="window['${cache[fn]}'](event)"`;
    // } else 
    if (key === "className") tag += ` class="${r.props[key]}"`;
    else tag += ` ${key}="${r.props[key]}"`;
  }
  tag += ">";
  return tag;
}

export function template(template, host) {
	return new Proxy(host, {
		construct(target, [config]) {
			const props = config.props || {};
			props.html = toStringExpensive(template(config.props));
			config.props = props;
			return new target(config);
		},
	});
}